__turbopack_context__.v({
  "activeFilter": "PedModelBrowser-module__5PqanG__activeFilter",
  "activeView": "PedModelBrowser-module__5PqanG__activeView",
  "card": "PedModelBrowser-module__5PqanG__card",
  "cardActions": "PedModelBrowser-module__5PqanG__cardActions",
  "cardBody": "PedModelBrowser-module__5PqanG__cardBody",
  "categoryTag": "PedModelBrowser-module__5PqanG__categoryTag",
  "clearSearch": "PedModelBrowser-module__5PqanG__clearSearch",
  "closeDialog": "PedModelBrowser-module__5PqanG__closeDialog",
  "codeFooter": "PedModelBrowser-module__5PqanG__codeFooter",
  "codeHeading": "PedModelBrowser-module__5PqanG__codeHeading",
  "codePanel": "PedModelBrowser-module__5PqanG__codePanel",
  "codeTitle": "PedModelBrowser-module__5PqanG__codeTitle",
  "copyModel": "PedModelBrowser-module__5PqanG__copyModel",
  "copySnippet": "PedModelBrowser-module__5PqanG__copySnippet",
  "detailHint": "PedModelBrowser-module__5PqanG__detailHint",
  "detailNavigation": "PedModelBrowser-module__5PqanG__detailNavigation",
  "detailRow": "PedModelBrowser-module__5PqanG__detailRow",
  "dialog": "PedModelBrowser-module__5PqanG__dialog",
  "dialogContent": "PedModelBrowser-module__5PqanG__dialogContent",
  "dialogFooter": "PedModelBrowser-module__5PqanG__dialogFooter",
  "dialogHeader": "PedModelBrowser-module__5PqanG__dialogHeader",
  "download": "PedModelBrowser-module__5PqanG__download",
  "emptyState": "PedModelBrowser-module__5PqanG__emptyState",
  "explorer": "PedModelBrowser-module__5PqanG__explorer",
  "eyebrow": "PedModelBrowser-module__5PqanG__eyebrow",
  "favoriteButton": "PedModelBrowser-module__5PqanG__favoriteButton",
  "feedback": "PedModelBrowser-module__5PqanG__feedback",
  "filters": "PedModelBrowser-module__5PqanG__filters",
  "grid": "PedModelBrowser-module__5PqanG__grid",
  "hashLine": "PedModelBrowser-module__5PqanG__hashLine",
  "intro": "PedModelBrowser-module__5PqanG__intro",
  "languageSwitch": "PedModelBrowser-module__5PqanG__languageSwitch",
  "largePreview": "PedModelBrowser-module__5PqanG__largePreview",
  "list": "PedModelBrowser-module__5PqanG__list",
  "modelDetails": "PedModelBrowser-module__5PqanG__modelDetails",
  "modelName": "PedModelBrowser-module__5PqanG__modelName",
  "noPreview": "PedModelBrowser-module__5PqanG__noPreview",
  "pagination": "PedModelBrowser-module__5PqanG__pagination",
  "previewButton": "PedModelBrowser-module__5PqanG__previewButton",
  "reset": "PedModelBrowser-module__5PqanG__reset",
  "resultRange": "PedModelBrowser-module__5PqanG__resultRange",
  "resultsHeading": "PedModelBrowser-module__5PqanG__resultsHeading",
  "searchBox": "PedModelBrowser-module__5PqanG__searchBox",
  "shortcut": "PedModelBrowser-module__5PqanG__shortcut",
  "sortLabel": "PedModelBrowser-module__5PqanG__sortLabel",
  "source": "PedModelBrowser-module__5PqanG__source",
  "srOnly": "PedModelBrowser-module__5PqanG__srOnly",
  "toolbar": "PedModelBrowser-module__5PqanG__toolbar",
  "viewSwitcher": "PedModelBrowser-module__5PqanG__viewSwitcher",
});
